export type ParsedVersion = {
  major: number;
  minor: number;
  patch: number;
};
export type Version = string | undefined | ParsedVersion;

export const parse = (v: Version): ParsedVersion | undefined => {
  if (typeof v !== 'string') return v;

  const [_, major, minor, patch] = v.match(/(\d+)[^\d]*[.](\d+)[^\d]*[.](\d+)/) || [];
  return {
    major: parseInt(major),
    minor: parseInt(minor),
    patch: parseInt(patch),
  };
};

const differ =
  (a: number, b: number, or = () => 0) =>
  () => {
    const d = a - b;
    return d > 0 ? 1 : d < 0 ? -1 : or();
  };

const _compare = (a: ParsedVersion | undefined, b: ParsedVersion | undefined) => {
  if (!a && !!b) return -1;
  if (!b && !!a) return 1;
  if (!a && !b) return 0;

  return differ(a!.major, b!.major, differ(a!.minor, b!.minor, differ(a!.patch, b!.patch)))();
};

export const compare = (a: Version, b: Version) => {
  return _compare(parse(a), parse(b));
};

export const gt = (a: Version, b: Version) => compare(a, b) > 0;
export const lt = (a: Version, b: Version) => compare(a, b) < 0;
export const eq = (a: Version, b: Version) => compare(a, b) === 0;
export const gte = (a: Version, b: Version) => compare(a, b) >= 0;
export const lte = (a: Version, b: Version) => compare(a, b) <= 0;
